import { API_BASE_URL, WAITLIST_VERSION } from "../../../config/env";

export const isUserAllowlisted = (address?: string) => {
  if (!address || address === "") {
    return false;
  }
  return true;
};

const ALLOWLIST_ENDPOINT_MAP = {
  ADD: `${API_BASE_URL}/waitlist/${WAITLIST_VERSION}/waitlist/add`,
  STATUS: `${API_BASE_URL}/waitlist/${WAITLIST_VERSION}/waitlist/status`,
  UPDATE: `${API_BASE_URL}/waitlist/${WAITLIST_VERSION}/waitlist/update`,
};

export const addToWaitlist = async (address: string, email?: string): Promise<boolean> => {
  try {
    const response = await fetch(ALLOWLIST_ENDPOINT_MAP.ADD, {
      method: "POST",
      body: JSON.stringify({
        address,
        email,
      }),
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json; charset=utf-8" },
    });
    if (response.ok) {
      const { accepted } = await response.json();
      return accepted as boolean;
    }
    return false;
  } catch (e) {
    console.error(`Could not add user ${address} to waitlist`, e);
    return false;
  }
};

export enum WaitlistStatus {
  NOT_IN_WAITLIST = "NOT_IN_WAITLIST",
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
}
export const getWaitlistStatus = async (
  address: string
): Promise<{ waitlistStatus: WaitlistStatus; hasEmail: boolean }> => {
  try {
    const response = await fetch(`${ALLOWLIST_ENDPOINT_MAP.STATUS}/${address}`);
    if (response.ok) {
      const { accepted, hasEmail } = await response.json();
      if (accepted) {
        return { waitlistStatus: WaitlistStatus.ACCEPTED, hasEmail: hasEmail as boolean };
      } else {
        return { waitlistStatus: WaitlistStatus.PENDING, hasEmail: hasEmail };
      }
    }
    return { waitlistStatus: WaitlistStatus.NOT_IN_WAITLIST, hasEmail: false };
  } catch (e) {
    console.error(`Could not fetch waitlist status for ${address}`, e);
    return { waitlistStatus: WaitlistStatus.NOT_IN_WAITLIST, hasEmail: false };
  }
};

export const addUserEmail = async (address: string, email: string): Promise<Response> => {
  if (!address || address === "") {
    console.error(`We don't have an address to add to the waitlist`);
    return new Response(undefined, { status: 400, statusText: "No address available" });
  }
  try {
    const response = await fetch(`${ALLOWLIST_ENDPOINT_MAP.UPDATE}/${address}`, {
      method: "POST",
      body: JSON.stringify({
        email,
      }),
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json; charset=utf-8" },
    });
    return response;
  } catch (e) {
    console.error(`Could not add user ${address}'s email to waitlist`, e);
    return new Response(undefined, {
      status: 400,
      statusText: "Failed to add address to waitlist",
    });
  }
};
